import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { WA_COUNTRIES } from "../lib/westafrica";

// Téléphone compatible avec les indicatifs ouest-africains.
export const PhoneInput = ({ value = "", onChange, testid = "phone" }) => {
  const match = WA_COUNTRIES.find((c) => value.startsWith(c.dial));
  const dial = match ? match.dial : "+221";
  const local = match ? value.slice(dial.length).trim() : value.replace(/^\+/, "");

  const emit = (d, l) => onChange(`${d} ${l}`.trim());

  return (
    <div className="flex gap-2">
      <Select value={dial} onValueChange={(d) => emit(d, local)}>
        <SelectTrigger data-testid={`${testid}-code`} className="w-32 shrink-0"><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-64">
          {WA_COUNTRIES.map((c) => (
            <SelectItem key={c.dial + c.name} value={c.dial}>{c.dial} · {c.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input data-testid={testid} value={local} onChange={(e) => emit(dial, e.target.value)}
        placeholder="77 123 45 67" className="flex-1" inputMode="tel" />
    </div>
  );
};
